import _URL from '../URL/index';
const axios = _URL.axios;
const limit = 15

export default {
    services: {
        getAreas(limit, page, query, token) {
            return axios(token).get(`/areas?limit=${limit}&page=${page}${query ? `&${query}` : ""}`);
        },
        getAreaById(areaId, token) {
            return axios(token).get(`/areas/${areaId}`);
        },
        createArea(area, token) {
            return axios(token).post(`/areas`, area);
        },
        updateAreaById(areaId, area, token) {
            return axios(token).put(`/areas/${areaId}`, area);
        },
        deleteAreaById(areaId, token) {
            return axios(token).delete(`/areas/${areaId}`);
        },
        deleteManyAreasById(areas, token) {
            return axios(token).post(`/bulk-delete-areas`, areas);
        },
        getAreasByBranchId(branchId, limit, page, token) {
            return axios(token).get(`/branches/${branchId}/areas?limit=${limit}&page=${page}`)
        },
        getAreasOptionsByBranchId(branchId, token) {
            return axios(token).get(`/branches/${branchId}/areas-options`)
        }
    }
}